import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Accordion, AccordionSummary, AccordionDetails } from '../styles';
import { getCurrencySymbol } from '../utils';

const amountStyle = {
  fontSize: 12,
  fontWeight: 'bold',
  minWidth: 100,
};

const HeaderRow = ({ title, count, total, symbol, expanded, expandable }) => (
  <Grid container justifyContent="space-between" style={{ margin: '10px 0px' }}>
    <Grid>
      <Grid container alignItems="center" style={{ width: 100 }}>
        <Typography style={{ fontSize: 12, fontWeight: 'bold' }}>
          {title}
        </Typography>
        {expandable && (
          <Grid style={{ position: 'relative', top: 4 }}>
            {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </Grid>
        )}
      </Grid>
    </Grid>
    <Typography style={{ fontSize: 12 }}>{count} Styles</Typography>
    <Typography align="right" style={amountStyle}>
      <span>{symbol}</span> {total}
    </Typography>
  </Grid>
);

export default function DeliverySummary({
  title,
  count,
  summary,
  currency,
  expanded,
  onToggle,
  panelId,
  expandable,
}) {
  const symbol = getCurrencySymbol(currency);

  if (!expandable) {
    return (
      <HeaderRow
        title={title}
        count={count}
        total={summary.total}
        symbol={symbol}
        expandable={false}
      />
    );
  }

  return (
    <Accordion
      square
      expanded={expanded}
      onChange={onToggle}
      style={{ boxShadow: 'none' }}
    >
      <AccordionSummary
        aria-controls={`${panelId}-content`}
        id={`${panelId}-header`}
        style={{ padding: 0, border: 0 }}
      >
        <HeaderRow
          title={title}
          count={count}
          total={summary.total}
          symbol={symbol}
          expanded={expanded}
          expandable
        />
      </AccordionSummary>
      <AccordionDetails
        style={{ padding: 0, marginLeft: 15, position: 'relative' }}
      >
        <Grid container>
          {summary.categories.map(({ key, label, qtd, price }) =>
            qtd > 0 ? (
              <Grid
                key={key}
                container
                justifyContent="space-between"
                style={{ margin: '3px 0px' }}
              >
                <Grid>
                  <Grid container alignItems="center">
                    <Typography
                      style={{ fontSize: 12, fontWeight: 'bold', width: 100 }}
                    >
                      {label}
                    </Typography>
                  </Grid>
                </Grid>
                <Typography style={{ fontSize: 12 }}>{qtd} Styles</Typography>
                <Typography align="right" style={amountStyle}>
                  <span>{symbol}</span> {price}
                </Typography>
              </Grid>
            ) : null
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
